import { render, staticRenderFns } from "./OrmItemComments.vue?vue&type=template&id=3bfa89b6&scoped=true"
import script from "./OrmItemComments.vue?vue&type=script&lang=js"
export * from "./OrmItemComments.vue?vue&type=script&lang=js"
import style0 from "./OrmItemComments.vue?vue&type=style&index=0&id=3bfa89b6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfa89b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bfa89b6')) {
      api.createRecord('3bfa89b6', component.options)
    } else {
      api.reload('3bfa89b6', component.options)
    }
    module.hot.accept("./OrmItemComments.vue?vue&type=template&id=3bfa89b6&scoped=true", function () {
      api.rerender('3bfa89b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/OrmItemComments.vue"
export default component.exports